import $ from 'jquery';
import FJConfig from '../config/FJConfig';
import Download from '../lib/download';
import FJLocalStore from "../store/FJLocalStore";

let loginCallback = [];
let fUserID = '';
let fProjectID = '';

export default {
    // getJumpUrl: function (url) {
    //     let tag = window.language_tag === 'en' ? '/' : '/' + window.language_tag
    //     let URL = tag + url
    //     return URL
    // },
    moveEnd: function (obj) {
        obj.focus();
        let len = obj.value.length;
        if (document.selection) {
            let sel = obj.createTextRange();
            sel.moveStart('character', len);
            sel.collapse();
            sel.select();
        } else if (typeof obj.selectionStart === 'number' && typeof obj.selectionEnd === 'number') {
            obj.selectionStart = obj.selectionEnd = len;
        }
    },
    filterStr: function (str) {
        return str.replace(/<script>|<\/script>/g, '');
    },
    getSelectionLength: function (myField) {
        return myField.selectionEnd - myField.selectionStart;
    },
    insertAtCursor: function (myField, myValue) {
        // IE support
        if (document.selection) {
            myField.focus();
            let sel = document.selection.createRange();
            sel.text = myValue;
        }
        // MOZILLA and others
        else if (myField.selectionStart || myField.selectionStart === 0) {
            let startPos = myField.selectionStart;
            let endPos = myField.selectionEnd;
            myField.value =
                myField.value.substring(0, startPos) + myValue + myField.value.substring(endPos, myField.value.length);
        } else {
            myField.value += myValue;
        }

        return myField.value;
    },
    setShareUserID: function (id) {
        fUserID = id;
    },
    getShareUserID: function () {
        return fUserID;
    },
    setShareProjectID: function (id) {
        fProjectID = id;
    },
    getShareProjectID: function () {
        return fProjectID;
    },
    getUserId: function () {
        return window.fjuser && window.fjuser.info && window.fjuser.info.id
            ? window.fjuser && window.fjuser.info && window.fjuser.info.id
            : '';
    },
    getQueryString: function (name) {
        let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
        let r = window.location.search.substr(1).match(reg);
        if (!r) return unescape(r[2]);
        else return null;
    },
    getLanguage: function (tag, callback) {
        fetch(FJConfig.languagePath + tag + '.json?v=' + FJConfig.buildVersion)
            .then(res => res.json())
            .then(json => {
                callback(json);
            })
            .catch(err => console.log(err));
    },
    addEvent: function (element, event, handler, useCapture = false) {
        if (!element) {
            return;
        }
        if (element.addEventListener) {
            element.addEventListener(event, handler, useCapture);
        } else if (element.attachEvent) {
            element.attachEvent('on' + event, handler);
        }
    },
    removeEvent: function (element, event, handler, useCapture = false) {
        if (!element) {
            return;
        }
        if (element.removeEventListener) {
            element.removeEventListener(event, handler, useCapture);
        } else if (element.detachEvent) {
            element.detachEvent('on' + event, handler);
        }
    },
    formatTime: function (time) {
        let m = Math.floor(time / 60);
        let s = Math.floor(time % 60);
        if (s < 10) s = '0' + s;
        return m + ':' + s;
    },
    valueOfInterval(value, min, max) {
        let result = 0;
        result = value < min ? min : value;
        result = result > max ? max : result;
        return result;
    },
    isPanelArea: function (e, object) {
        if (!e) {
            return false;
        }
        let point = {
            x: e.clientX,
            y: e.clientY,
        };

        try {
            let rect = {
                x: object.getBoundingClientRect().left,
                y: object.getBoundingClientRect().top,
                width: $(object).outerWidth(),
                height: $(object).outerHeight(),
            };
            return this.isPointInRect(point, rect);
        } catch (e) {
            return false;
        }
    },
    isPointInRect: function (point, rect) {
        if (point.x >= rect.x && point.x <= rect.x + rect.width && point.y >= rect.y && point.y <= rect.y + rect.height)
            return true;
        return false;
    },
    isLocalhost: function () {
        return Boolean(
            window ||
            window.location.hostname === 'localhost' ||
            // [::1] is the IPv6 localhost address.
            window.location.hostname === '[::1]' ||
            // 127.0.0.1/8 is considered localhost for IPv4.
            window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/) ||
            window.location.hostname.match(/^192.168(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){2}$/),
        );
    },
    isLogin: function () {
        return window.fjuser && window.fjuser.info && window.fjuser.info.id;
    },
    anonymousSignUp: function () {
        return new Promise((resolve, reject) => {
            if (window.PanelFunc && window.PanelFunc.showSignUpPane) {
                window.PanelFunc.showSignUpPane();
                window.loginToCreateProjectCallback = () => {
                    loginCallback.forEach(callback => {
                        callback();
                    });
                    resolve();
                };
            } else {
                reject(new Error('error in anonymousSignUp'));
            }
        });
    },
    downloadVideo: function (videoUrl) {
        if (this.getBrowser() === 'FF') {
            Download(videoUrl);
        } else {
            const save_link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
            save_link.href = videoUrl;
            save_link.click();
        }
    },
    copy: function (text) {
        const input = document.createElement('input');
        document.body.appendChild(input);
        input.value = text; // 修改文本框的内容
        input.select(); // 选中文本
        document.execCommand('copy'); // 执行浏览器复制命令
        document.body.removeChild(input);
    },
    toLocalTime: function (time) {
        return time - new Date(time).getTimezoneOffset() * 60000;
    },
    formatTimeZone: function (time) {
        let date = new Date(time);
        const month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        let Y = date.getFullYear() + ' ';
        let M = month[date.getMonth()] + ' ';
        let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ', ';
        // h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':';
        // m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':';
        // s = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds());
        return M + D + Y;
    },
    /**
     * @desc 转换时间格式
     * @param {string} date - 例如2020-07-03 06:35:55
     * @return {number}
     */
    convertTime: function (date) {
        let newDate = date.substring(0, 19);
        newDate = newDate.replace(/-/g, '/');
        return new Date(newDate).getTime();
    },
    /**
     * @description 格式化数字（货币格式）
     * @param num
     * @returns {string}
     */
    toThousands: function (num) {
        return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
    },

    /**
     * @description 判断是不是测试环境
     * @returns {boolean}
     */
    isTest: function () {
        return import.meta.env.VITE_CURRENT_PUBLIC_SERVER_TAG_TYPE !== 'release';
    },

    /**
     * @description 判断是否是手机端访问
     * @returns {boolean}
     */
    isMobile: function () {
        const ua = navigator.userAgent.toLowerCase();
        if (ua.match(/mobile/)) {
            return true;
        }
        return false;
    },

    /**
     * @desc 获取当前浏览器
     * @return {string}
     */
    getBrowser: function () {
        const userAgentDataBrowserList = ['Google Chrome', 'Opera', 'Microsoft Edge'];
        if (navigator && navigator.userAgentData) {
            const userAgentData = navigator.userAgentData;
            const isMobile = userAgentData.mobile ? '.Mobile' : '';
            const brands = userAgentData.brands;

            let browser = '';
            for (let i = 0; i < brands.length; i++) {
                const brand = brands[i].brand;
                if (userAgentDataBrowserList.indexOf(brand) !== -1) {
                    switch (brand) {
                        case userAgentDataBrowserList[0]: {
                            browser = 'Chrome' + isMobile;
                            break;
                        }
                        case userAgentDataBrowserList[1]: {
                            browser = 'Opera' + isMobile;
                            break;
                        }
                        case userAgentDataBrowserList[2]: {
                            browser = 'Edge' + isMobile;
                            break;
                        }
                    }
                    break;
                }
            }

            if (browser) {
                return browser;
            }
        }

        let Sys = {};
        let ua = navigator.userAgent.toLowerCase();
        let s;
        let isMobile = '';

        // eslint-disable-next-line no-unused-expressions
        (s = ua.match(/rv:([\d.]+)\) like gecko/))
            ? (Sys.ie = s[1])
            : (s = ua.match(/msie ([\d.]+)/))
                ? (Sys.ie = s[1])
                : (s = ua.match(/edge\/([\d.]+)/))
                    ? (Sys.edge = s[1])
                    : (s = ua.match(/edg\/([\d.]+)/))
                        ? (Sys.edge = s[1])
                        : (s = ua.match(/firefox\/([\d.]+)/))
                            ? (Sys.firefox = s[1])
                            : (s = ua.match(/opera.([\d.]+)/))
                                ? (Sys.opera = s[1])
                                : (s = ua.match(/opr\/([\d.]+)/))
                                    ? (Sys.opera = s[1])
                                    : (s = ua.match(/chrome\/([\d.]+)/))
                                        ? (Sys.chrome = s[1])
                                        : (s = ua.match(/version\/([\d.]+).*safari/))
                                            ? (Sys.safari = s[1])
                                            : 0;

        if (ua.match(/mobile/)) {
            isMobile = '.Mobile';
        }

        if (Sys.ie) return 'IE' + isMobile;
        if (Sys.edge) return 'Edge' + isMobile;
        if (Sys.firefox) return 'FF' + isMobile;
        if (Sys.opera) return 'Opera' + isMobile;
        if (Sys.safari) return 'Safari' + isMobile;
        if (Sys.chrome) return 'Chrome' + isMobile;
    },

    /**
     * @description 埋点统计
     * @param eventType
     * @param eventData
     */
    ealog: function (eventType, eventData) {
        if (window && window.ealog && window.ealog.addEvent) {
            window.ealog.addEvent(eventType, eventData);
        }else {
            console.log(eventType, eventData)
        }
    },
    getPricingUri: function() {
        return FJLocalStore.currentTag() !== 'en' ? `/${FJLocalStore.currentTag()}/pricing.html` : '/pricing.html';
    },
    getTeamPricingUri: function () {
        return FJLocalStore.currentTag() !== 'en' ? `/${FJLocalStore.currentTag()}/team/pricing.html` : '/team/pricing.html';
    },
    getCookie: function(name) {
        let matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    },
    calculateTextDimensions: function(text, fixedWidth, font) {
        // Create an off-screen DOM element
        const offScreenElement = document.createElement('div');

        // Set the element's position, width, and font properties
        offScreenElement.style.position = 'absolute';
        offScreenElement.style.opacity = "0";
        offScreenElement.style.width = fixedWidth + 'px';
        offScreenElement.style.font = font;

        // Add the text to the element
        const words = text.split(' ');
        words.forEach((word, index) => {
            const span = document.createElement('span');
            span.textContent = word + (index !== words.length - 1 ? ' ' : '');
            offScreenElement.appendChild(span);
        });

        // Append the element to the DOM
        document.body.appendChild(offScreenElement);

        let maxWidth = 0;
        let lineWidth = 0;
        let prevSpanRight = 0;

        // Calculate the maximum line width
        offScreenElement.childNodes.forEach((span, index) => {
            const spanRect = span.getBoundingClientRect();
            if (index === 0) {
                lineWidth = spanRect.width;
            } else {
                if (spanRect.left >= prevSpanRight) {
                    lineWidth += spanRect.width;
                } else {
                    maxWidth = Math.max(maxWidth, lineWidth);
                    lineWidth = spanRect.width;
                }
            }
            prevSpanRight = spanRect.right;
        });
        maxWidth = Math.max(maxWidth, lineWidth);

        // Measure the dimensions of the element
        const dimensions = {
            width: maxWidth,
            height: offScreenElement.clientHeight,
        };

        // Remove the element from the DOM
        document.body.removeChild(offScreenElement);

        return dimensions;
    }

};
